'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/accessibility/AccessibilityIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AccessibilityIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5 4.33325C8.08172 4.33325 4.5 7.91497 4.5 12.3333C4.5 16.7515 8.08172 20.3333 12.5 20.3333C16.9183 20.3333 20.5 16.7515 20.5 12.3333C20.5 7.91497 16.9183 4.33325 12.5 4.33325ZM2.5 12.3333C2.5 6.8104 6.97715 2.33325 12.5 2.33325C18.0228 2.33325 22.5 6.8104 22.5 12.3333C22.5 17.8561 18.0228 22.3333 12.5 22.3333C6.97715 22.3333 2.5 17.8561 2.5 12.3333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5205 10.8334C13.0727 10.844 13.5118 11.3001 13.5013 11.8523C13.4848 12.7186 13.6299 13.3435 13.8919 13.8873C14.1623 14.4488 14.5849 14.9831 15.2186 15.6378C15.6027 16.0347 15.5923 16.6678 15.1954 17.0518C14.7986 17.4359 14.1655 17.4256 13.7814 17.0287C13.0937 16.3181 12.498 15.6024 12.09 14.7552C11.6734 13.8904 11.48 12.9479 11.5016 11.8142C11.5122 11.262 11.9683 10.8229 12.5205 10.8334Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4778 10.8335C13.0299 10.8222 13.4867 11.2607 13.4979 11.8129C13.5207 12.9281 13.3564 13.8737 12.9494 14.7485C12.5475 15.6125 11.9411 16.3371 11.192 17.0551C10.7934 17.4373 10.1603 17.424 9.77813 17.0253C9.39594 16.6266 9.40929 15.9936 9.80797 15.6114C10.468 14.9787 10.881 14.4533 11.1361 13.9049C11.3861 13.3674 11.5164 12.7384 11.4984 11.8536C11.4871 11.3015 11.9256 10.8447 12.4778 10.8335Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.6362 10.0926L9.64014 10.0931L9.65415 10.095L9.7108 10.1025C9.7607 10.1091 9.83397 10.1185 9.92585 10.1299C10.1098 10.1527 10.3673 10.1832 10.6604 10.2136C11.2562 10.2754 11.9636 10.3332 12.4998 10.3332C13.036 10.3332 13.7435 10.2754 14.3395 10.2136C14.6327 10.1832 14.8903 10.1527 15.0743 10.1299C15.1662 10.1185 15.2395 10.1091 15.2894 10.1025L15.3461 10.095L15.3601 10.0931L15.3634 10.0926C15.9105 10.0175 16.4156 10.4 16.4908 10.9471C16.566 11.4943 16.1834 11.9988 15.6362 12.0739L15.5001 11.0832C15.6362 12.0739 15.6363 12.0739 15.6362 12.0739L15.6296 12.0748L15.6127 12.0771L15.5498 12.0855C15.4956 12.0926 15.4175 12.1027 15.3204 12.1147C15.1263 12.1388 14.8552 12.1708 14.5459 12.2029C13.9369 12.2661 13.1443 12.3332 12.4998 12.3332C11.8553 12.3332 11.0628 12.2661 10.454 12.2029C10.1448 12.1708 9.87369 12.1388 9.67969 12.1147C9.58259 12.1027 9.50453 12.0926 9.45034 12.0855L9.3875 12.0771L9.37059 12.0748L9.36462 12.074C9.36456 12.074 9.36395 12.0739 9.50011 11.0832L9.36462 12.074C8.81748 11.9988 8.43422 11.4942 8.50942 10.9471C8.58462 10.4 9.08909 10.0174 9.6362 10.0926Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 8.33325C11 7.50482 11.6716 6.83325 12.5 6.83325C13.3284 6.83325 14 7.50482 14 8.33325C14 9.16168 13.3284 9.83325 12.5 9.83325C11.6716 9.83325 11 9.16168 11 8.33325Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/accessibility/WheelchairIcon.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var WheelchairIcon = (props) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M15.0624 19.0001C14.0113 20.3683 12.3586 21.2501 10.5 21.2501C7.32436 21.2501 4.75 18.6758 4.75 15.5001C4.75 12.8434 6.55176 10.6075 9 9.94775M15.0624 19.0001C15.1855 18.8399 15.3004 18.6731 15.4063 18.5001L15.0624 19.0001Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M19.0001 15.75L19.9595 16.0321C20.0484 15.7298 19.9896 15.4032 19.8008 15.1509C19.612 14.8985 19.3152 14.75 19.0001 14.75V15.75ZM16.7907 19.7178C16.6349 20.2477 16.9381 20.8035 17.4679 20.9593C17.9978 21.1152 18.5536 20.812 18.7094 20.2821L17.7501 20L16.7907 19.7178ZM11.1306 12.8469L10.1801 12.5362C10.1779 12.543 10.1757 12.5498 10.1736 12.5567L11.1306 12.8469ZM13.0158 10.2985C13.1874 9.7736 12.901 9.20892 12.3761 9.0373C11.8511 8.86568 11.2865 9.1521 11.1148 9.67704L12.0653 9.98779L13.0158 10.2985ZM13.2837 15.75V16.75H19.0001V15.75V14.75H13.2837V15.75ZM19.0001 15.75L18.0407 15.4678L16.7907 19.7178L17.7501 20L18.7094 20.2821L19.9595 16.0321L19.0001 15.75ZM13.2837 15.75V14.75C12.4448 14.75 11.844 13.94 12.0875 13.1372L11.1306 12.8469L10.1736 12.5567C9.54056 14.6439 11.1026 16.75 13.2837 16.75V15.75ZM12.0653 9.98779L11.1148 9.67704L10.1801 12.5362L11.1306 12.8469L12.0811 13.1577L13.0158 10.2985L12.0653 9.98779Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M12 12H16",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx2(
          "circle",
          {
            cx: "13.5",
            cy: "5",
            r: "2.25",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    })
  );
};

export {
  AccessibilityIcon,
  WheelchairIcon
};
//# sourceMappingURL=chunk-O3KDFYXJ.mjs.map